import { useQContent } from '@exam-management/common/qcontent-provider';
import { Chip, Flex, ReadonlyField, Text } from '@shared/components';

import { QuestionContentPreviewer } from '../../components';
import { getCognitiveDomain } from '../../utils';

export default function PropertiesView() {
  const { qContent } = useQContent();

  const cognitiveDomain = getCognitiveDomain(qContent.tags);

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
        <Text variant='body2Semibold'>คุณลักษณะของข้อสอบ (Cognitive Domain)</Text>
        <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
          {cognitiveDomain.map((domain) => (
            <Chip key={domain.value} label={domain.label} />
          ))}
        </Flex>
      </Flex>
      <ReadonlyField
        label='วัตถุประสงค์การเรียนรู้ (LOS)'
        content={qContent.learningObjectiveStatement?.tag.name ?? 'ไม่ระบุ'}
      />
      <ReadonlyField
        label='คำอธิบายเฉลย'
        content={
          <QuestionContentPreviewer
            content={qContent.solution?.value ?? 'ไม่ระบุ'}
            questionId={qContent.id}
          />
        }
      />
      <ReadonlyField
        label='หนังสืออ้างอิง'
        content={
          <QuestionContentPreviewer
            content={qContent.metadata.reference ?? 'ไม่ระบุ'}
            questionId={qContent.id}
          />
        }
      />
    </Flex>
  );
}
